import { defineMessages } from 'react-intl';
export default defineMessages({
    login: {
        id: 'app.containers.Auth.login',
        defaultMessage: 'Login',
    },
    logout: {
        id: 'app.containers.Auth.logout',
        defaultMessage: 'Logout',
    },
    error: {
        id: 'app.containers.Auth.error',
        defaultMessage: 'Error: {error}',
    },
    noRedirectUrl: {
        id: 'app.containers.Auth.noRedirectUrl',
        defaultMessage: 'No redirect URL found',
    },
    missingTenantId: {
        id: 'app.containers.Auth.missingTenantId',
        defaultMessage: 'Please use the link provided in your invitation email.',
    },
    missingTenantIdHeading: {
        id: 'app.containers.Auth.missingTenantIdHeading',
        defaultMessage: 'Invalid login link',
    },
});
